import { render, staticRenderFns } from "./serviceInfo.vue?vue&type=template&id=7272cdc8&"
import script from "./serviceInfo.vue?vue&type=script&lang=js&"
export * from "./serviceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports